import { type } from './utils'

export default function isFunction(fn) {
	return type(fn) === 'Function'
}
